// Currently the base package provides CLDR assets only
import "./generated/json-imports/LocaleData.js";
